APP.PaymentStatus = (function () {
	'use strict';

	var exports,
		$body,
		previousResponseStatus;

	function init() {
		$body = APP.Performance.getCachedDOM().$body;
		if ($body.find('[data-payment-status]').length > 0) {
			loadData();
		}
	}

	function loadData() {
		var paymentType,
			$typeItem,
			$amount;

		APP.Service.get({}, $body.find('[data-payment-status]').attr('data-payment-status')).then(function (response) {

			if (response.data.status !== previousResponseStatus) {
				drawOutResponse(response.data);
				$typeItem = $body.find('[data-payment-type]');
				$amount = $body.find('[data-payment-amount]');
				paymentType = $typeItem && $typeItem.attr('data-payment-type') || 'unknown';
				APP.Analytics.trackEvent('onlinepayment', paymentType, getStatusText(response.data.status.toLowerCase()));

				if (paymentType.toLowerCase() === 'topup' && $amount) {
					APP.Analytics.trackEvent('onlinepayment', 'topup', $amount.attr('data-payment-amount'));
				}
			}

			if (!response.data.ready) {
				window.setTimeout(loadData, response.data.delay);
			}

			previousResponseStatus = response.data.status;

		});
	}

	function getStatusText(code) {
		var status = 'UNKNOWN';

		switch (code) {
		case 'none':
		case 'r':
		case 'ta':
			status = 'FAIL';
			break;
		case 'pok':
		case 'tf':
			status = 'SUCCESS';
			break;
		case 'up':
		case 'op':
		case 'pm':
			status = 'INPROGRESS';
			break;
		}

		return status;

	}

	function drawOutResponse(data) {
		$body.find('[data-payment-status]').html(
			APP.Template.get('payment-status')(data)
		);
	}

	exports = {
		init: init
	};

	return exports;

}());
